function isActivity(cell): boolean {
  return Boolean(cell && cell.parent && Number(cell.parent.id) === 2);
}

function isSticker(cell): boolean {
  return Boolean(cell && cell.parent && Number(cell.parent.id) === 7);
}

function isText(cell): boolean {
  return Boolean(cell && cell.parent && Number(cell.parent.id) === 4);
}

function isImage(cell): boolean {
  return Boolean(cell && cell.parent && Number(cell.parent.id) === 5);
}

function isConnector(cell): boolean {
  return Boolean(cell && cell.parent && Number(cell.parent.id) === 9) && cell.value !== 'X';
}

function isTerminator(cell): boolean {
  return Boolean(cell && cell.parent && Number(cell.parent.id) === 9) && cell.value === 'X';
}

function isFlowline(cell): boolean {
  return Boolean(cell && cell.edge);
}

function isLineText(cell): boolean {
  return Boolean(cell && cell.parent?.edge && cell.key);
}

function isInteraction(cell): boolean {
  return Boolean(cell && cell.parent?.edge && !cell.key);
}

function isExtended(cell): boolean {
  return Boolean(cell && cell.getJson && typeof cell.getJson === 'function');
}

function getCellName(cell): string {
  cell = cell || {};
  const types = [
    {match: isActivity, type: 'activity'},
    {match: isFlowline, type: 'flowline'},
    {match: isConnector, type: 'connector'},
    {match: isTerminator, type: 'terminator'},
    {match: isSticker, type: 'sticker'},
    {match: isText, type: 'text'},
    {match: isImage, type: 'image'}
  ];

  for (let i = 0; i < types.length; i++) {
    if (types[i].match(cell)) {
      return types[i].type;
    }
  }

  return '';
}

function isComponent(cell): boolean {
  return Boolean(cell.div && cell.comp && cell.div instanceof HTMLElement);
}

function hasDTAttachment(cell): boolean {
  if (!isActivity(cell)) {
    return false;
  }

  const json = cell.getJson();

  return !!json?.attachments?.find(att => att.type === 'datatable');
}

function hasAttachment(cell): boolean {
  if (!isActivity(cell)) {
    return false;
  }

  const json = cell.getJson();

  return !!json?.attachments?.length;
}

/**
 * Checks if cell has attachment of given type
 * @param type
 * Note Attachment == 'text' |
 * URL == 'url' |
 * DataTable == 'datatable' |
 * Image == 'image' |
 */
function hasAttachmentOfType(type: string): (cell: any) => boolean {
  return cell => {
    if (!hasAttachment(cell)) {
      return false;
    }

    const json = cell.getJson();

    return !!json?.attachments?.find(att => att.type === type);
  };
}

function hasDrilldown(cell): boolean {
  if (!cell) {
    return false;
  }

  const json = cell.getJson();

  return !!json?.drilldowns?.length;
}

function hasLinkedDiagram(cell): boolean {
  if (!cell) {
    return false;
  }

  const json = cell.getJson();

  return !!json?.linkedDiagram;
}

function hasDrilldownOrLinkedDiagram(cell) {
  if (!cell) {
    return false;
  }

  const json = cell.getJson();

  return !!json?.drilldowns?.length || json?.linkedDiagram;
}

export {
  isActivity,
  isSticker,
  isText,
  isImage,
  isConnector,
  isTerminator,
  isFlowline,
  getCellName,
  isComponent,
  hasDTAttachment,
  hasDrilldown,
  isExtended,
  isLineText,
  isInteraction,
  hasAttachmentOfType,
  hasLinkedDiagram,
  hasDrilldownOrLinkedDiagram
};
